import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-confirmation-message',
  templateUrl: './confirmation-message.component.html',
  styleUrls: ['./confirmation-message.component.scss']
})
export class ConfirmationMessageComponent implements OnInit {

  constructor() { }
  private readonly val1: string = '';
  private readonly val2: string = '';

  ngOnInit() {
  }

  public getNewHtml(string, val1, val2){
    while (string.includes('%val1%')){
      string = string.replace('%val1%', val1);
    }
    while (string.includes('%val2%')){
      string = string.replace('%val2%', val2);
    }
    return string;
  }
}
